import DOCUMENTATION_PRODUCT_NAME from 'utilities/uTagging';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import { OTP_TRANSFER_VIEW, DOCUMENTATION_VIEW } from 'constants/steps';
import { PATH_DOCUMENTATION_FINISHED } from 'constants/uTagConstants/paths';
import { PROCESS_TYPE_ONBOARDING } from 'utilities/uTagConstants';
import { TRANSFER_OTP_PATH, TRANSFER_OTP_PATH_STEP } from 'constants/uTagConstants/paths';
import { recordPage, RELIABLE, recordEvent, recordEventStepSuccess } from 'utilities/uTagging';
import cryptoJS from 'crypto-js';
import { getGA4EventKeys } from 'utilities/ga4';

export const doTagShowHelpModal = () =>
    recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        accionEvento: 'otp-ibanid/modal-te-ayudamos',
        etiquetaEvento: 'vista',
        categoriaEvento: 'eventos IBAN OTP',
    });

export const doTagToggleAlternativeOptionModal = investmentType =>
    recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        ...getGA4EventKeys({
            eventName: 'step_standby',
            pageName: '/onboarding/step10/standby',
            processDetail: 'standby',
            onboardingType: investmentType,
        }),
        accionEvento: 'otp-ibanid/modal-espera-transferencia',
        etiquetaEvento: 'vista',
        categoriaEvento: 'eventos IBAN OTP',
        processStep: 'step10',
    });

export const doTagCheckBoxAlternativeOption = tagEvent =>
    recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        accionEvento: 'otp-ibanid',
        etiquetaEvento: tagEvent,
        categoriaEvento: 'eventos IBAN OTP',
    });

export const doTagOnPageReload = ({
    encryptedDocNumber,
    identityMethod,
    investmentType,
    jointHolderInfo,
    product,
    productsDescription,
    promoCode,
    recordId,
    userId,
}) => {
    const customData = {
        ...getGA4EventKeys({
            eventName: 'step_otp',
            pageName: '/onboarding/step9/otp',
            processDetail: 'otp',
            onboardingType: investmentType,
        }),
        identificadorOnboarding: encryptedDocNumber,
        tipoProceso: PROCESS_TYPE_ONBOARDING,
        pasoProceso: TRANSFER_OTP_PATH_STEP,
        detalleProceso: '',
        nombreProducto: DOCUMENTATION_PRODUCT_NAME,
        processStep: 'step9',
    };
    recordPage(
        TRANSFER_OTP_PATH,
        recordId,
        userId,
        product,
        productsDescription,
        promoCode ? promoCode : '',
        jointHolderInfo,
        RELIABLE[identityMethod],
        '',
        investmentType,
        customData
    );

    return customData.pageName;
};

export const doTagContinueButton = () =>
    recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        accionEvento: 'otp-ibanid',
        etiquetaEvento: 'continuar',
        categoriaEvento: 'eventos IBAN OTP',
    });

export const doTagSuccessfulEvent = investmentType =>
    recordEventStepSuccess(investmentType, '/onboarding/documentacion/ibanid', 'verificacion seguridad', {
        event_name: 'event_success',
        action: 'success',
        format: 'steps',
        component: 'funnel',
        element: 'otp',
    });

export const doTagCheckAndRecordWhichTagForSuccessStatus = ({
    jointHolderInfo,
    channel,
    clientRisk,
    docNumber,
    documentationStatusCounter,
    identityMethod,
    immStepsState,
    investmentType,
    product,
    products,
    promoCode,
    recordId,
    userId,
}) => {
    const currentStep = immStepsState.get('steps').getIn([immStepsState.get('currentStep')]);

    const POSSIBLE_PATHS = {
        [DOCUMENTATION_VIEW]: { path: PATH_DOCUMENTATION_FINISHED, detalleProceso: 'finalizado' },
        [OTP_TRANSFER_VIEW]: { path: PATH_DOCUMENTATION_FINISHED, detalleProceso: 'finalizado-otp' },
    };

    const pageName = POSSIBLE_PATHS[currentStep.toJS().stepName].path;

    recordPage(
        pageName,
        recordId,
        userId,
        product,
        products.get('productsDescription'),
        promoCode ? promoCode : '',
        jointHolderInfo,
        RELIABLE[identityMethod],
        '',
        investmentType,
        {
            tipoProceso: PROCESS_TYPE_ONBOARDING,
            pasoProceso: 'documentacion',
            detalleProceso: POSSIBLE_PATHS[currentStep.toJS().stepName].detalleProceso,
            onboardingContFinal: documentationStatusCounter > 0 ? 2 : 1,
            onboardingR: clientRisk || '',
            onboardingIdMethod: RELIABLE[identityMethod],
            devId: '1taggingDocumentation',
            nombreProducto: DOCUMENTATION_PRODUCT_NAME,
            identificadorOnboarding: docNumber ? cryptoJS.SHA256(docNumber).toString() : '',
            onboardingOrigin: ORIGIN_BY_CHANNEL[channel],
        }
    );

    return pageName;
};
